import { FunctionComponent, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import SiteLogo from "../icons/anil-logo.svg";
import { SocialLinks } from "./SocialLinks";
import HamburgerIcon from "../icons/hamburger.svg";
import CloseIcon from "../icons/close.svg";
import classNames from "classnames";

export const Header: FunctionComponent = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const { wpMenu } = useStaticQuery(
    graphql`
      {
        wpMenu(name: {}, slug: { eq: "primary" }) {
          menuItems {
            nodes {
              title
              url
              target
              label
            }
          }
        }
      }
    `
  );
  return (
    <header className="header glass backdrop-blur-md p-2 md:p-3 lg:p-4 mb-2 md:mb-8 z-20">
      <Link
        className="logo flex justify-center flex-col items-center text-center"
        to="/"
      >
        <SiteLogo className="w-8 h-8 sm:w-10 md:w-12 lg:w-16 mt-1 md:my-4 fill-current" />
        <span className="text-sm md:text-lg text-gray-700 dark:text-gray-200">
          Anil Maharjan
        </span>
      </Link>
      <button
        onClick={() => {
          setMenuOpen((prev) => !prev);
        }}
        className="absolute top-0 right-0 p-5 md:hidden z-50"
      >
        {menuOpen ? (
          <CloseIcon className="inline w-4 h-4" />
        ) : (
          <HamburgerIcon className="inline w-4 h-4" />
        )}
      </button>
      <nav
        className={classNames(
          "md:!block fixed w-full h-screen right-0 top-0 z-40 max-w-52 p-10 md:p-2 bg-gradient-to-tr bg-blue-300/95 shadow-lg md:bg-transparent md:bg-none md:shadow-none md:static md:h-auto md:max-w-full",
          menuOpen ? "block" : "hidden"
        )}
      >
        <ul className="mx-auto mt-6 mb-3 max-w-6xl flex gap-8 flex-col  md:flex-wrap md:flex-row md:justify-center">
          {wpMenu.menuItems.nodes.map((menuItem: any) => (
            <li key={menuItem.url}>
              <Link
                to={menuItem.url}
                role="menuitem"
                className="menu-link p-2 px-2 md:px-0"
                activeClassName="active"
              >
                {menuItem.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <SocialLinks />
    </header>
  );
};
